// src/components/ScorecardInputTable.js
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
} from "@mui/material";

const ScorecardInputTable = ({ holes, handleHoleChange, holeCount, holeOffset = 0 }) => {
  // Build a complete array for the number of holes.
  // Include "yardage", "par", and "handicap" in the default object.
  const completeHoles = Array.from({ length: holeCount }, (_, i) =>
    holes[i + holeOffset] || { yardage: "", par: "", handicap: "" }
  );

  // Common input props to disable spinner arrows.
  const inputProps = {
    style: {
      fontSize: "0.8rem",
      padding: "4px",
      WebkitAppearance: "none", // Chrome, Safari, Edge
      MozAppearance: "textfield", // Firefox
      appearance: "textfield", // Standard
    },
    autoComplete: "off",
  };

  return (
    <TableContainer component={Paper} sx={{ mt: 2, mb: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ padding: "4px" }} />
            {Array.from({ length: holeCount }, (_, i) => (
              <TableCell key={`header-${i}`} align="center" sx={{ padding: "4px" }}>
                {i + holeOffset + 1}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {/* Yardage Row */}
          <TableRow>
            <TableCell sx={{ padding: "4px" }}>Yardage</TableCell>
            {completeHoles.map((hole, idx) => (
              <TableCell key={`yard-${idx}`} align="center" sx={{ padding: "4px" }}>
                <TextField
                  type="number"
                  value={hole.yardage}
                  onChange={(e) =>
                    handleHoleChange(idx + holeOffset, "yardage", e.target.value)
                  }
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{
                    inputProps: inputProps,
                    sx: {
                      '& input[type=number]': {
                        '-moz-appearance': 'textfield',
                        '&::-webkit-outer-spin-button': { '-webkit-appearance': 'none', margin: 0 },
                        '&::-webkit-inner-spin-button': { '-webkit-appearance': 'none', margin: 0 },
                      },
                    },
                  }}
                />
              </TableCell>
            ))}
          </TableRow>
          {/* Handicap Row */}
          <TableRow>
            <TableCell sx={{ padding: "4px" }}>Handicap</TableCell>
            {completeHoles.map((hole, idx) => (
              <TableCell key={`hcp-${idx}`} align="center" sx={{ padding: "4px" }}>
                <TextField
                  type="number"
                  value={hole.handicap}
                  onChange={(e) =>
                    handleHoleChange(idx + holeOffset, "handicap", e.target.value)
                  }
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{
                    inputProps: inputProps,
                    sx: {
                      '& input[type=number]': {
                        '-moz-appearance': 'textfield',
                        '&::-webkit-outer-spin-button': { '-webkit-appearance': 'none', margin: 0 },
                        '&::-webkit-inner-spin-button': { '-webkit-appearance': 'none', margin: 0 },
                      },
                    },
                  }}
                />
              </TableCell>
            ))}
          </TableRow>
          {/* Par Row */}
          <TableRow>
            <TableCell sx={{ padding: "4px" }}>Par</TableCell>
            {completeHoles.map((hole, idx) => (
              <TableCell key={`par-${idx}`} align="center" sx={{ padding: "4px" }}>
                <TextField
                  type="number"
                  value={hole.par}
                  onChange={(e) =>
                    handleHoleChange(idx + holeOffset, "par", e.target.value)
                  }
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{
                    inputProps: inputProps,
                    sx: {
                      '& input[type=number]': {
                        '-moz-appearance': 'textfield',
                        '&::-webkit-outer-spin-button': { '-webkit-appearance': 'none', margin: 0 },
                        '&::-webkit-inner-spin-button': { '-webkit-appearance': 'none', margin: 0 },
                      },
                    },
                  }}
                />
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ScorecardInputTable;